export const observation = {
  name_one: "observation",
  name_other: "observations",
  observationDate: "Observation date",
  observationDateColumn: "Observation \n date",
  concernedAsset: "Concerned asset",
  assetType: "Asset type",
  createdBy: "Created by",
  id: "Id",
  name: "Name",
  risk: {
    label: "Risk",
    low: "Low",
    moderate: "Moderate",
    high: "High",
    critical: "Critical",
    none: "None",
  },
  sourceIntervention: "Source intervention",
  sourceObservationLink: "Go to observation's section",
  sourceInterventionStateColumn: "Source intervention \n status",
  recommendedInterventions: {
    title: "Recommendations",
  },
  dueDays: "Maximum intervention time",
  images: "Photos ({{count}})",
  noImage: "No photo",
  position: "Position",
  noPosition: "No position",
  users: "Users",
  description: "Description",
  summary: "Summary",
  severity: "Severity",
  source: {
    probability: "Probability",
    consequence: "Consequence",
    component: "Component",
    material: "Material",
    defect: "Defect",
  },
  statistics: {
    riskLevel: {
      title: "Risk level",
    },
    state: {
      title: "Status",
    },
  },
  batchEdit: {
    title: "Modification of observations",
    state: {
      optionTitle: "Status of observations",
    },
    severity: {
      optionTitle: "Severity of observations",
    },
  },
  batchEditSelect: {
    selected_one: "selected observation.",
    selected_other: "selected observations.",
  },
  batchEditSeverity: {
    formError:
      "An error occurred while updating observations. No observations have been modified.",
  },
  batchTransition: {
    description_one: "Please apply a new status to the selected observation.",
    description_other:
      "Please apply a new status to the different selected observations.",
    info: "Completed and discarded observations cannot be modified.",
    formSuccess:
      "All observations '{{initialState}}' have been changed to '{{newState}}' state.",
    formErrorGeneric:
      "An error occurred while editing observations '{{initialState}}'.",
    formErrorItems:
      "The following observations could not be modified: {{items}}.",
  },
  validation: {
    validate: "Validate the observation",
    invalidate: "Invalidate",
    user: "Validated by {{name}}",
    date: "The {{date}}",
  },
  delete: {
    button: "Delete the observation",
    sidePanel: {
      title: "Delete the observation",
      description:
        "Are you sure you want to delete the observation <strong>{{name}}</strong>?",
    },
    relatedItemsDesc:
      "Deleting the observation will also delete all associated elements:",
    relatedItemsTypes: {
      form: "Form information",
      file: "Files",
      gps: "GPS",
      cartesian: "Cartesian positioning",
      image: "Images",
      planPositioning: "Plan positioning",
      comment: "Comments",
      recommendation: "The recommendation",
      interventions: "Recommended interventions",
    },
  },
};
